import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, Menu, notification } from "antd";
import { useMsal } from "@azure/msal-react";

import {
  CaretDownOutlined,
  CaretUpOutlined,
  LoadingOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";

import useUserData from "hooks/useUserData";
import LinkWithParams from "components/elements/LinkWithParams";

import styles from "./UserMenu.module.less";

function UserMenu(): JSX.Element {
  const [dropdownVisible, setDropdownVisible] = useState<boolean>(false);
  const { t } = useTranslation();
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const userData = useUserData();

  const handleLogout = async () => {
    try {
      setIsLoading(true);
      const accounts = instance.getAllAccounts();
      const account = accounts[0];
      await instance.logoutRedirect({
        account,
        onRedirectNavigate: () => true,
      });
    } catch (e) {
      notification.error({ message: t("something_went_wrong") });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dropdown
      trigger={["click"]}
      visible={dropdownVisible}
      onVisibleChange={() => setDropdownVisible(!dropdownVisible)}
      overlay={
        <Menu theme="light">
          <Menu.Item
            key="settings"
            icon={<SettingOutlined className={styles.icon} />}
          >
            <LinkWithParams
              to="/user"
              onClick={() => setDropdownVisible(false)}
            >
              <span>{t("header.settings")}</span>
            </LinkWithParams>
          </Menu.Item>
          <Menu.Item
            key="logout"
            icon={
              isLoading ? (
                <LoadingOutlined className={styles.icon} spin={isLoading} />
              ) : (
                <LogoutOutlined className={styles.icon} />
              )
            }
            onClick={handleLogout}
            disabled={isLoading}
          >
            <span>{t("header.logout")}</span>
          </Menu.Item>
        </Menu>
      }
    >
      <div className={styles.dropdown_wrapper}>
        <UserOutlined className={styles.user_icon} />
        <p className={styles.user_name}>{userData?.email}</p>
        {dropdownVisible ? <CaretUpOutlined /> : <CaretDownOutlined />}
      </div>
    </Dropdown>
  );
}

export default UserMenu;
